import { suspend } from "suspend-react";

export const useSuspenseImport = <TModule>(importer: () => Promise<TModule>) => {
  return suspend(importer, []);
};
